export default {
  // Index
  scheduleAMeeting: {
    english: "Schedule an Appointment",
    spanish: "Programar una reunión",
  },
  // Available-Time-Slots
  chooseATopic: {
    english: "Please choose a Topic",
    spanish: "Escoge un tema",
  },
  date: {
    english: "Date",
    spanish: "Fecha",
  },
  chooseWith: {
    english: "Choose with",
    spanish: "Elige con quien",
  },
  chooseATimeSlot: {
    english: "Please select with",
    spanish: "Elige con quien",
  },
  noFoundTimeSlots: {
    english: "Sorry, we could not find any Time Slots.",
    spanish: "Lo sentimos, no pudimos encontrar ninguna franja horaria.",
  },
  // submit is from profile

  // Time-Slot-Search-Form
  selectADate: {
    english: "Select A Date",
    spanish: "Seleccione una fecha",
  },
  enterDescription: {
    english: "Enter description",
    spanish: "Ingrese una descripción"
  },
  chooseAChatType: {
    english: "Enter the Chat type",
    spanish: "Ingrese el tipo de chat"
  },
  scheduleNew:{
    english:'Schedule New',
    spanish: "Programar una reunión",
  },

  today: {
    english: "Today",
    spanish: "Hoy"
  }
};
